module.exports = __webpack_public_path__ + "img/map-mobile.7c78ea6c.png";